<template>
	<o-section :title="setup.modalTitle">
		<o-carousel
			v-model="setup.step"
			color="info"
			hide-navigation-buttons>
			<template #poster="{ stepIndex }">
				<organization-release-note-animation
					v-if="stepIndex < 4"
					:step="stepIndex + 1"/>
			</template>

			<o-carousel-item name="intro">
				<o-section title="Restructuration">
					<p>Bienvenue chez vous... avant cette <b>refonte des droits</b> !</p>
					<p>
						Cette version 5.0.0 d'Armado inclut des fondations indispensables et transparentes pour cimenter les évolutions à venir,
						mais également son <i>petit</i> lot de fonctionnalités.
					</p>
					<p>Les étapes qui vont suivre sont là pour <b>vous guider dans la création de votre organisation</b>.</p>
					<p>Soyez rassurés, il n'y a rien de bien sorcier, juste à suivre le guide 😉</p>
				</o-section>
			</o-carousel-item>

			<o-carousel-item name="vision">
				<o-section title="Une vision d'ensemble">
					<p>
						Rien de plus frustrant que d'avoir à naviguer parmi plusieurs pages d'un site
						avant de trouver l'information que vous cherchiez 🧐 !
					</p>
					<p>Pour <i>organiser</i> cela, nous avons donc pensé à <b>l'organisation</b>.</p>
					<p>
						À la fin de ce tuto, vous aurez regroupé l'ensemble de vos sociétés sous <b>un dénominateur commun</b>
						{{ setup.self.isAgency() ? '.' : `qui deviendra le point de référence pour vos agences d'emploi.` }}
					</p>
					<p>Vous donnant par ailleurs <b>une vision d'ensemble</b> de vos entreprises et vos utilisateurs.</p>
				</o-section>
			</o-carousel-item>

			<o-carousel-item name="roles">
				<o-section title="Les rôles">
					<p>Plus votre société <b>grandit</b>, plus les utilisateurs sont <b>nombreux</b> et nécessitent des accès bien particuliers.</p>
					<p>
						Plutôt que de gérer au cas par cas, vous pourrez dorénavant créer <b>un rôle</b>
						pour l'ensemble de vos sociétés.
					</p>
					<p>
						{{
							setup.self.isAgency()
								? `Assistant administratif, stagiaire, responsable Grands Comptes...`
								: `Gestionnaire de paie, assistant RH, chef de chantier...`
						}}
						<br>
						Peu importe le nom que vous donnerez à ce rôle,
						vous pourrez lui affecter <b>des droits bien précis</b> et le répercuter à la volée sur <b>un ensemble d'utilisateurs</b> !
					</p>
				</o-section>
			</o-carousel-item>

			<o-carousel-item name="tags">
				<o-section title="Les tags">
					<p>
						Dernier focus de ce tuto, et non des moindres ☝️, <b>les tags</b> vont venir affiner encore un peu plus
						<b>ce que peuvent voir et faire les utilisateurs</b> !
					</p>
					<p v-if="setup.self.isAgency()">
						Pour vous, comme pour vos entreprises utilisatrices.
					</p>
					<p v-else>
						Ils vous serviront dans de multiples situations :
						<ul>
							<li>n'autoriser <b>l'accès</b> à certains documents qu'à certaines personnes.</li>
							<li>créer des <b>filtres personnalisés</b> pour vos documents.</li>
							<li><b>automatiser</b> l'affectation de documents à certains services lors du dépôt par votre agence partenaire.</li>
						</ul>
					</p>
					<p>Nous rentrerons dans le détail à la fin de ce tutoriel !</p>
				</o-section>
			</o-carousel-item>

			<o-carousel-item
				name="company-list"
				lazy>
				<organization-release-note-company-list class="mb-md"/>
			</o-carousel-item>

			<o-carousel-item
				name="form"
				lazy>
				<organization-release-note-form/>
			</o-carousel-item>

			<template #actions="{ goNextStep, goPreviousStep, step, stepIndex }">
				<o-section
					class="mt-sm"
					align="stretch">
					<o-button
						v-if="stepIndex > 0"
						outline
						prefix-font-icon="icon-interface-arrows-button-left"
						@click="goPreviousStep()">
						Précédent
					</o-button>

					<o-button
						v-if="!['tags', 'form'].includes(step)"
						outline
						suffix-font-icon="icon-interface-arrows-button-right"
						@click="goNextStep()">
						Suivant
					</o-button>
					<o-button
						v-else-if="step === 'tags'"
						outline
						color="info"
						@click="goNextStep()">
						C'est parti
					</o-button>

					<div
						v-if="step === 'form'"
						id="organization-release-note-additional-action"
						style="flex:1 0 13%"/>
				</o-section>
			</template>
		</o-carousel>
	</o-section>
</template>

<script setup lang="ts">
import OrganizationReleaseNoteAnimation from './OrganizationReleaseNoteAnimation.vue';
import OrganizationReleaseNoteCompanyList from './OrganizationReleaseNoteCompanyList.vue';
import OrganizationReleaseNoteForm from './OrganizationReleaseNoteForm.vue';
import OrganizationReleaseNoteSetupService from '@/setup/organization/OrganizationReleaseNoteSetupService';
const props = defineProps(OrganizationReleaseNoteSetupService.props);
const setup = new OrganizationReleaseNoteSetupService(props);
</script>

<style scoped lang="less">
:deep(.orion-carousel__navigation) {
  order: 2;
  margin-bottom: 1.5rem;
}
:deep(.orion-carousel__steps-wrapper) {
  order: 3;
}
:deep(.orion-carousel__actions) {
  order: 4;
}
</style>
